/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * 
 * @export
 * @interface RequestInfoSubscriber
 */
export interface RequestInfoSubscriber {
    /**
     * Subscriber's first name
     */
    first_name?: string;
    /**
     * Subscriber's middle name
     */
    middle_name?: string;
    /**
     * Subscriber's last name
     */
    last_name?: string;
    /**
     * Subscriber's member ID
     */
    member_id?: string;
    /**
     * Subscriber's date of birth
     */
    date_of_birth?: Date;
    /**
     * Subscriber's MBI end date
     */
    mbi_end_date?: Date;
    /**
     * 
     */
    address?: Address;
}

/**
 * Check if a given object implements the RequestInfoSubscriber interface.
 */
export function instanceOfRequestInfoSubscriber(value: object): value is RequestInfoSubscriber {
    return true;
}

export function RequestInfoSubscriberFromJSON(json: any): RequestInfoSubscriber {
    return RequestInfoSubscriberFromJSONTyped(json, false);
}

export function RequestInfoSubscriberFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestInfoSubscriber {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'member_id': json['member_id'] == null ? undefined : json['member_id'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : (parseDateTime(json['date_of_birth'])),
        'mbi_end_date': json['mbi_end_date'] == null ? undefined : (parseDate(json['mbi_end_date'])),
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
    };
}

export function RequestInfoSubscriberToJSON(json: any): RequestInfoSubscriber {
    return RequestInfoSubscriberToJSONTyped(json, false);
}

export function RequestInfoSubscriberToJSONTyped(value?: RequestInfoSubscriber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'member_id': value['member_id'],
        'date_of_birth': value['date_of_birth'] == null ? value['date_of_birth'] : serializeDateTime(value['date_of_birth']),
        'mbi_end_date': value['mbi_end_date'] == null ? value['mbi_end_date'] : serializeDate(value['mbi_end_date']),
        'address': AddressToJSON(value['address']),
    };
}

